/**
 * Screenshot confirmation request
 */
export interface ScreenshotConfirmRequest {
  /** Number of DOM blocks (notes, frames, images) - require slow html2canvas */
  domBlockCount: number;
  /** Number of shapes - use fast Canvas 2D API, negligible time */
  shapeCount: number;
  resolve: (confirmed: boolean) => void;
}

/**
 * Global event name for screenshot confirmation
 */
export const SCREENSHOT_CONFIRM_EVENT = 'affine-screenshot-confirm';

/**
 * Dispatch screenshot confirmation request
 * Returns a Promise that resolves to true (confirmed) or false (cancelled)
 *
 * @param domBlockCount - Number of DOM blocks (notes, frames, images) that need html2canvas
 * @param shapeCount - Number of shapes that use fast Canvas 2D API (optional, for display only)
 */
export function requestScreenshotConfirm(
  domBlockCount: number,
  shapeCount: number = 0
): Promise<boolean> {
  return new Promise(resolve => {
    window.dispatchEvent(
      new CustomEvent<ScreenshotConfirmRequest>(SCREENSHOT_CONFIRM_EVENT, {
        detail: { domBlockCount, shapeCount, resolve },
      })
    );
  });
}
